<template>
  <el-dialog :visible.sync="visible" :title="$t('roomOweFees.title')" width="80%" top="5vh" custom-class="custom-modal"
    @close="handleClose">
    <el-table :data="roomOweFeesInfo.fees" stripe border style="width: 100%; margin-top: 15px">
      <el-table-column prop="payerObjName" :label="$t('roomOweFees.payerObj')" align="center" />
      <el-table-column prop="configName" :label="$t('roomOweFees.feeItem')" align="center" />
      <el-table-column prop="ownerName" :label="$t('roomOweFees.ownerName')" align="center" />
      <el-table-column prop="ownerTel" :label="$t('roomOweFees.phone')" align="center" />
      <el-table-column prop="endTime" :label="$t('roomOweFees.startTime')" align="center" />
      <el-table-column prop="deadlineTime" :label="$t('roomOweFees.endTime')" align="center" />
      <el-table-column prop="amountOwed" :label="`${$t('roomOweFees.total')} (${$t('roomOweFees.unit')})`"
        align="center" />
      <el-table-column prop="updateTime" :label="$t('roomOweFees.updateTime')" align="center" />
      <el-table-column :label="$t('common.operation')" align="center" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openItems(scope.row)">
            {{ $t('common.view') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="pagination.total > 0" background layout="prev, pager, next" :total="pagination.total"
      :page-size="pagination.pageSize" :current-page="pagination.currentPage" @current-change="handlePageChange"
      style="margin-top: 20px; text-align: right" />

    <!-- 欠费项明细弹窗：append-to-body 脱离外层弹窗层级，避免嵌套遮挡/重叠 -->
    <el-dialog :title="$t('roomOweFees.itemsTitle')" :visible.sync="itemsVisible" width="60%" append-to-body
      custom-class="items-dialog">
      <el-table :data="currentItems" border stripe>
        <el-table-column prop="feeName" :label="$t('roomOweFees.feeItem')" align="center" />
        <el-table-column prop="amountOwed" :label="`${$t('roomOweFees.total')} (${$t('roomOweFees.unit')})`"
          align="center" />
        <el-table-column prop="startTime" :label="$t('roomOweFees.startTime')" align="center" />
        <el-table-column prop="endTime" :label="$t('roomOweFees.endTime')" align="center" />
      </el-table>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getRoomOweFees } from '@/api/room/roomOweFeesApi'

export default {
  name: 'RoomOweFees',
  data() {
    return {
      visible: false,
      roomOweFeesInfo: {
        fees: [],
        roomId: ''
      },
      pagination: {
        total: 0,
        pageSize: 10,
        currentPage: 1
      },
      itemsVisible: false,
      currentItems: []
    }
  },
  methods: {
    open(roomId) {
      this.roomOweFeesInfo.roomId = roomId
      this.pagination.currentPage = 1
      this.visible = true
      this.loadData()
    },
    openItems(row) {
      this.currentItems = (row && row.items) || []
      this.itemsVisible = true
    },
    handleClose() {
      this.visible = false
    },
    handlePageChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadData()
    },
    async loadData() {
      try {
        const params = {
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          communityId: this.getCommunityId(),
          payerObjId: this.roomOweFeesInfo.roomId,
          payerObjType: '3333'
        }

        const response = await getRoomOweFees(params)
        this.roomOweFeesInfo.fees = response.data
        this.pagination.total = response.total
      } catch (error) {
        console.error('加载房屋欠费信息失败:', error)
        this.$message.error(this.$t('common.loadFailed'))
      }
    },

  }
}
</script>

<style scoped>
.custom-modal>>>.el-dialog__body {
  padding: 15px 20px;
}

.items-dialog {
  z-index: 3000 !important;
}
</style>